import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'elem-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonComponent implements OnInit {

    @Input()
    buttonRole: 'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'SMALL' = 'PRIMARY';

    @Input()
    icon: string;

    @Input()
    disabled = false;

    type = 'button';


    constructor() {
    }

    ngOnInit(): void {
    }

    getDisabled(): boolean {
        return this.disabled;
    }

    getClasses() {
        const result = [];

        switch (this.buttonRole) {
            case 'PRIMARY':
                result.push('btn--primary');
                break;
            case 'SECONDARY':
                result.push('btn--secondary');
                break;
            case 'TERTIARY':
                result.push('btn--tertiary');
                break;
            case 'SMALL':
                result.push('btn--small');
                break;
        }

        return result;
    }
}
